import { render } from "./polygon-legend.vue?vue&type=template&id=57e95fb3&scoped=true"
import script from "./polygon-legend.vue?vue&type=script&lang=js"
export * from "./polygon-legend.vue?vue&type=script&lang=js"

import "./polygon-legend.vue?vue&type=style&index=0&id=57e95fb3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e95fb3"]])

export default __exports__